import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const AddClientNote = (props) => {
  const [content, setContent] = useState(props.client.note);
  const [loading, setLoading] = useState(false);

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const checkIfIdentifierisUniqe = async (id) => {
    var rows = await props.clientsContactSheetData.getRows();
    var arr = rows.filter((el) => el.identifier === id);

    if (arr.length > 0) {
      return false;
    }

    return true;
  };

  const addClientNote = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        id: props.client.id,
        note: content.toString().replaceAll("'", ""),
      };

      await fetch("https://apidevkppp.ftpeople.pl/addNoteClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction("Dodano notatkę do sprawy", props.client.id);

      MySwal.fire({
        icon: "success",
        title: "Dodano",
        text: "notatkę do sprawy",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (content.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            <div className="inputBox">
              <div className="inputCol_1">
                <label>Treść notatki</label>
                <textarea
                  spellCheck="false"
                  className="textAreaNote"
                  type="text"
                  id="url"
                  name="url"
                  value={content}
                  onChange={handleContentChange}
                />
              </div>
            </div>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={addClientNote}>
                zapisz
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddClientNote;
